import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { SupplementalInfoService } from './supplemental-info.service';
import {CurrencyPipe} from "@angular/common";
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-supplemental-info',
    templateUrl: './supplemental-info.component.html',
    styleUrls: ['./supplemental-info.component.scss'],
    providers: [CurrencyPipe],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SupplementalInfoComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  baseGlobalParams: any;

  baseURLs: GtwElementsBaseUrlsModel ={'admin':'','api':'/gtw',"custom":'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  
  private comboKey :number = 0;
  private baseURL = '/custom';
  private baseURLGtw = '/gtw';
  private taxYear :number = 0;
  private scenario :number = 0;
  private jcdKey :number = 0;
  private screenKey :number = 0;
  private ssoId: string = '';
  private scenarioCode: string = '';
  private checkLockedObj: any = [];
  
  /** Optional overlay when host still binds combination key explicitly. */
  @Input('cc-key')
	set _comboKey(comboKey:number){
	  this.comboKey = Number(comboKey) || 0;
    this.comboKeyFromInput = true;
	  this.tryInit();
	}

  private comboKeyFromInput = false;

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  @Output('open-supplemental-info')
  openSupplementalInfo = new EventEmitter<string>();

  @Output('save-supplemental-info')
  saveSupplementalInfo = new EventEmitter<string>();

  minimise = false;

  

  subscriptions = new Subscription();

  constructor(
    private SupplementalInfoService: SupplementalInfoService,
    private currencyPipe: CurrencyPipe,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef
  ) { }

  private toCheckboxBool(value: any): boolean {
    if (value === true || value === 1) {
      return true;
    }
    const normalized = String(value ?? '').trim().toUpperCase();
    return normalized === 'YES' || normalized === 'Y' || normalized === 'TRUE' || normalized === '1';
  }

  /** API save expects legacy checkbox payload ("true" / ""), not display "Yes". */
  private toApiCheckboxValue(checked: boolean): string {
    return checked ? 'true' : '';
  }

  private resolveIssueListItem(dataedit?: any, editvalue?: any): any {
    if (!this.issueIdList?.length) {
      return null;
    }
    const key = editvalue ?? dataedit?.ISSUE_KEY ?? dataedit?.ISSUE_ID;
    const id = dataedit?.ISSUE_ID;
    return this.issueIdList.find((item: any) =>
      item.value === key ||
      item.value === id ||
      String(item.value) === String(key) ||
      (id != null && String(item.value) === String(id))
    ) ?? null;
  }

  private applyIssueSelectionForEdit(dataedit?: any, editvalue?: any): void {
    const match = this.resolveIssueListItem(dataedit, editvalue);
    this.issueIdList.forEach((item: any) => {
      item.selected = false;
    });
    if (match) {
      match.selected = true;
      this.selectedIssueItem = match;
    }
  }

  private getSelectedIssueKey(): number {
    if (this.scenarioDesc === 'RAF') {
      return 0;
    }
    if (this.isEditFlag && this.editIssueid != null && this.editIssueid !== '') {
      return Number(this.editIssueid);
    }
    const selectedIndex = _.findIndex(this.issueIdList, { selected: true });
    if (selectedIndex >= 0) {
      return this.issueIdList[selectedIndex].value;
    }
    if (this.selectedIssueItem?.value != null) {
      return this.selectedIssueItem.value;
    }
    return 0;
  }

  issueIdList : any = [];
	
	SavedData : any = [];
	tempGroupData : any = { };
	tableData = false;
    PurInvUsRel : any;
	PurInvNonUsRel : any;
	CostSales: any;
	WageCostSales : any;
	SalesTangPropUs : any;
	SalesTangPropNonUs : any;
	PurTangPropUs : any;
	PurTangPropNonUs : any;
	BuyInRecveUs : any;
	BuyInRecveNonUs : any;
	BuyInPaidUs : any;
	BuyInPaidNonUs : any;
	CostSharRecveUs : any;
	CostSharRecveNonUs : any;
	CostSharPaidUs : any;
	CostSharPaidNonUs : any;
	sanctionedCountry = false;
    illegalPayments = false;
	editIssueid : any;
	selectedIssueid  : any = [];
	selectedIssueItem: any = null;
	autoRunDataLoad = false;
	scenarioDesc: string = '';
	isEditFlag = false;
	isResetFlag = false;
	tableLoadingData = false;
	rafDataFlag = false;
	durationInSeconds= 5;
	issueIdCheckFlag = false;

	// Snapshot of the row being edited so that Reset in edit mode restores the original values
	private editingDataOriginal: any = null;
	
	checkInputType():boolean{
		if(Number.isInteger(parseInt(this.taxYear+"")) &&
		  Number.isInteger(parseInt(this.scenario+'')) &&
		  Number.isInteger(parseInt(this.jcdKey +'')) &&
		  Number.isInteger(parseInt(this.screenKey+'')) &&
		  Number.isInteger(parseInt(this.comboKey+'')) &&
		  Number.isInteger(parseInt(this.ssoId+"")) &&
		  (this.scenarioCode === "RAF" || this.scenarioCode === "EXAM") 
		  )
		{
		  return true;
		}
	
		return false;
	}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.subscriptions.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subscriptions.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const fp = normalizeFilterParams(activeScreen);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj || this.checkLockedObj;
    this.taxYear = Number(fp?.tax_year ?? this.baseGlobalParams?.tax_year ?? this.taxYear ?? 0);
    this.scenario = Number(fp?.scenario ?? this.baseGlobalParams?.scenario ?? this.scenario ?? 0);
    this.jcdKey = Number(fp?.jcd_key ?? this.baseGlobalParams?.jcd_key ?? this.jcdKey ?? 0);
    this.screenKey = Number(fp?.screen_key ?? this.baseGlobalParams?.screen_key ?? this.screenKey ?? 0);
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    this.ssoId = sso != null && sso !== '' ? String(sso) : this.ssoId;
    this.scenarioCode = String(
      fp?.scenarioCode ??
        fp?.scenario_code ??
        this.baseGlobalParams?.scenarioCode ??
        this.baseGlobalParams?.scenario_code ??
        this.scenarioCode ??
        ''
    );
    this.scenarioDesc = this.scenarioCode;
    const row = rowPayloadFromActiveScreen(activeScreen);
    const rowObj = Array.isArray(row) ? (row[0]?.data ?? row[0]) : extractObject(row);
    if (!this.comboKeyFromInput) {
      const cc =
        rowObj?.COMBINATION_KEY ??
        rowObj?.combination_key ??
        fp?.combination_key ??
        fp?.COMBINATION_KEY ??
        this.baseGlobalParams?.combination_key ??
        this.baseGlobalParams?.COMBINATION_KEY;
      if (cc != null && cc !== '') {
        this.comboKey = Number(cc);
      }
    }
  }

  init() {
	    if(this.checkInputType()){
			this.getIssueIdData();
			this.getModalSaveData();
		}
	}

  private tryInit(): void {
    if (!this.checkInputType()) {
      return;
    }
    this.init();
  }

    onChangeEvent(event: any) {
      console.log(event);
  }

  onClickButtonEvent(event: any) {
      console.log(event);
  }

  public floatingConfig = {
    isFloating: true
	}

  btnClickDelete(dataf : any) {
	let tempDataDel = {
		TAX_YEAR : this.baseGlobalParams?.tax_year,
		SCENARIO : this.baseGlobalParams?.scenario,
		JCD_KEY : this.baseGlobalParams?.jcd_key,
		COMBINATION_KEY: this.comboKey,
		SSO_ID: this.ssoId,
		ISSUE_KEY : dataf.ISSUE_KEY
	}
		this.SupplementalInfoService.deleteSupplInfoData(this.baseURLs.api, tempDataDel, this.baseGlobalParams, this.checkLockedObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
		if (data.callSuccess == "1") {
			this.SupplementalInfoService.openSnackBar('Data Deleted Successfully','gtw-snackbar--green');
			this.isEditFlag = false;
			this.editingDataOriginal = null;
			this.refreshSavedData();
			this.saveSupplementalInfo.emit('save-supplemental-info');
		} else {
			this.SupplementalInfoService.openSnackBar('Error Deleting Data. '+data.errorMessage, 'gtw-snackbar--red');
		}
			}, () => {
				console.log("Error while saving");
		});
	}

	btnClickEdit(dataedit : any) {
		this.isEditFlag = true;
		this.isResetFlag = false;
		this.rafDataFlag = false;
		this.editingDataOriginal = JSON.parse(JSON.stringify(dataedit));
		this.populateFormFromData(dataedit);
		if (this.scenarioDesc !== 'RAF') {
			this.applyIssueSelectionForEdit(dataedit, dataedit.ISSUE_KEY);
		}
		this.cdr.detectChanges();
	}

	private populateFormFromData(dataedit: any): void {
		this.editIssueid = dataedit.ISSUE_KEY;
		this.illegalPayments = this.toCheckboxBool(dataedit.ILLEGAL_PAYMENTS);
		this.sanctionedCountry = this.toCheckboxBool(dataedit.SANCTIONED_COUNTRY);
		this.PurInvUsRel = dataedit.PURCHASE_INV_US_RELATED ?? null;
		this.PurInvNonUsRel = dataedit.PURCHASE_INV_NONUS_RELATED ?? null;
		this.CostSales = dataedit.COST_OF_SALES ?? null;
		this.WageCostSales = dataedit.WAGES_COST_OF_SALES ?? null;
		this.SalesTangPropUs = dataedit.SALES_TANGIBLE_PROP_US ?? null;
		this.SalesTangPropNonUs = dataedit.SALES_TANGIBLE_PROP_NONUS ?? null;
		this.PurTangPropUs = dataedit.PURCHASE_TANGIBLE_PROP_US ?? null;
		this.PurTangPropNonUs = dataedit.PURCHASE_TANGIBLE_PROP_NONUS ?? null;
		this.BuyInRecveUs = dataedit.BUY_IN_RECEIVE_US ?? null;
		this.BuyInRecveNonUs = dataedit.BUY_IN_RECEIVE_NONUS ?? null;
		this.BuyInPaidUs = dataedit.BUY_IN_PAID_US ?? null;
		this.BuyInPaidNonUs = dataedit.BUY_IN_PAID_NONUS ?? null;
		this.CostSharRecveUs = dataedit.COST_SHARING_RECEIVE_US ?? null;
		this.CostSharRecveNonUs = dataedit.COST_SHARING_RECEIVE_NONUS ?? null;
		this.CostSharPaidUs = dataedit.COST_SHARING_PAID_US ?? null;
		this.CostSharPaidNonUs = dataedit.COST_SHARING_PAID_NONUS ?? null;
	}

	private clearForm(): void {
		this.illegalPayments = false;
		this.sanctionedCountry = false;
		this.PurInvUsRel = null;
		this.PurInvNonUsRel = null;
		this.CostSales = null;
		this.WageCostSales = null;
		this.SalesTangPropUs = null;
		this.SalesTangPropNonUs = null;
		this.PurTangPropUs = null;
		this.PurTangPropNonUs = null;
		this.BuyInRecveUs = null;
		this.BuyInRecveNonUs = null;
		this.BuyInPaidUs = null;
		this.BuyInPaidNonUs = null;
		this.CostSharRecveUs = null;
		this.CostSharRecveNonUs = null;
		this.CostSharPaidUs = null;
		this.CostSharPaidNonUs = null;
	}

	resetData(){
		this.autoRunDataLoad = false;
		this.issueIdCheckFlag = false;

		if (this.isEditFlag && this.editingDataOriginal) {
			// Edit mode: restore original values from the row that was opened for edit
			this.isResetFlag = false;
			this.populateFormFromData(this.editingDataOriginal);
			if (this.scenarioDesc !== 'RAF') {
				this.applyIssueSelectionForEdit(this.editingDataOriginal, this.editingDataOriginal.ISSUE_KEY);
			}
			this.cdr.detectChanges();
			return;
		}

		// Add mode: clear all fields and reset issue selection
		this.isResetFlag = true;
		this.selectedIssueid = [];
		this.selectedIssueItem = null;
		this.clearForm();
		if (this.scenarioDesc !== 'RAF') {
			this.setIssueId(this.tempGroupData, this.editIssueid);
		}
	};
  
  getTestData(){
	
  }

  saveData(){ 
	         const issueKey = this.getSelectedIssueKey();
	         if (this.scenarioDesc !== 'RAF' && !issueKey) {
				   this.issueIdCheckFlag = true;
				   return;
			   }
				this.issueIdCheckFlag = false;
			
			let tempData = {
				TAX_YEAR : this.baseGlobalParams?.tax_year,
				SCENARIO : this.baseGlobalParams?.scenario,
				JCD_KEY : this.baseGlobalParams?.jcd_key,
				COMBINATION_KEY: this.comboKey,
				SSO_ID: this.ssoId,
				ISSUE_KEY: issueKey,
				PURCHASE_INV_US_RELATED : this.PurInvUsRel,
				PURCHASE_INV_NONUS_RELATED : this.PurInvNonUsRel,
				WAGES_COST_OF_SALES : this.WageCostSales,
				SALES_TANGIBLE_PROP_US : this.SalesTangPropUs,
				SALES_TANGIBLE_PROP_NONUS : this.SalesTangPropNonUs,
				PURCHASE_TANGIBLE_PROP_US : this.PurTangPropUs,
				PURCHASE_TANGIBLE_PROP_NONUS : this.PurTangPropNonUs,
				BUY_IN_RECEIVE_US : this.BuyInRecveUs,
				BUY_IN_RECEIVE_NONUS : this.BuyInRecveNonUs,
				BUY_IN_PAID_US : this.BuyInPaidUs,
				BUY_IN_PAID_NONUS : this.BuyInPaidNonUs,
				COST_SHARING_RECEIVE_US : this.CostSharRecveUs,
				COST_SHARING_RECEIVE_NONUS : this.CostSharRecveNonUs,
				COST_SHARING_PAID_US : this.CostSharPaidUs,
				COST_SHARING_PAID_NONUS : this.CostSharPaidNonUs,
				SANCTIONED_COUNTRY : this.toApiCheckboxValue(this.sanctionedCountry),
				ILLEGAL_PAYMENT: this.toApiCheckboxValue(this.illegalPayments)
			}
					
					this.SupplementalInfoService.saveSupplInfoData(this.baseURLs.api, tempData, this.baseGlobalParams, this.checkLockedObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
						(data) => {
							if (data.callSuccess == "1") {
								this.SupplementalInfoService.openSnackBar('Data Saved Successfully','gtw-snackbar--green');
								this.isEditFlag = false;
								this.isResetFlag = false;
								this.editingDataOriginal = null;
								this.refreshSavedData();
								this.saveSupplementalInfo.emit('save-supplemental-info');
								this.requestGridUpdate.emit('refresh');
							} else {
								this.SupplementalInfoService.openSnackBar('Error Saving Data. '+data.errorMessage, 'gtw-snackbar--red');
							}
						}, () => {
							console.log("Error while saving");
					});
    };

  setIssueId(group : any, editvalue?: any){
		const selected = Array.isArray(group?.selected) ? group.selected : (group?.selected ? [group.selected] : []);
		const change = selected[0] ?? null;

		if (this.isEditFlag && !this.isResetFlag) {
			this.applyIssueSelectionForEdit(this.editingDataOriginal, editvalue);
			return;
		}

		if (this.isResetFlag) {
			this.issueIdList.forEach((item: any) => {
				item.selected = false;
			});
			this.selectedIssueItem = null;
			this.isResetFlag = false;
			if (this.isEditFlag) {
				this.isEditFlag = false;
			}
			return;
		}

		this.selectedIssueid = selected[0]?.value;
		this.selectedIssueItem = change;
		this.issueIdCheckFlag = false;
	}

  getIssueIdData(){
		this.issueIdList = [];
		this.scenarioDesc = this.scenarioCode;
		this.SupplementalInfoService.getIssueIdData(this.baseURLs.api, this.baseGlobalParams,this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if (data) {
				let tempIssueId : any = [];
				data.forEach( (value : any) => {
						let tempChannel = {
							value: value.ISSUE_ID,
							label: value.ISSUE_SHORT_DESC,
							selected: false
						}
						tempIssueId.push(tempChannel);
				});
				this.issueIdList = tempIssueId;
				if (this.isEditFlag && this.editingDataOriginal && this.scenarioDesc !== 'RAF') {
					this.applyIssueSelectionForEdit(this.editingDataOriginal, this.editingDataOriginal.ISSUE_KEY);
				}
				this.cdr.detectChanges();
			}
		},
		error => {
		  this.autoRunDataLoad = false;
		  console.log(error);
		}, () => {
		  this.autoRunDataLoad = false;
		});

		
	}

	getModalSaveData(force = false){
		if (!force && (this.SavedData.length > 0 || this.autoRunDataLoad)) {
			return;
		}
		this.autoRunDataLoad = true;
		this.SupplementalInfoService.getSupplModalData(this.baseURLs.api, this.baseGlobalParams, this.comboKey, this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
			(data: any) => {
				this.autoRunDataLoad = false;
				this.tableLoadingData = true;
				if (data?.length > 0) {
					this.tableData = true;
					this.SavedData = data;
					if (this.scenarioDesc === 'RAF' && data.length === 1) {
						this.rafDataFlag = true;
					}
				} else {
					this.tableData = false;
					this.SavedData = [];
				}
				this.cdr.detectChanges();
			},
			() => {
				this.autoRunDataLoad = false;
				this.tableLoadingData = true;
			}
		);
	}

	private refreshSavedData(): void {
		this.getModalSaveData(true);
	}

	modalClose() {
		this.openSupplementalInfo.emit('cancel-suppl-update');
		this.requestGridUpdate.emit('cancel');
	}

	cancel() {
		this.requestGridUpdate.emit('cancel');
	}

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.label || item?.text || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }

}
